import React from "react";
import Loadable from "react-loadable";

import DotSpinner from "@exovera/dot-spinner";

function Loading() {
	return (
		<div className="map__loader">
			<DotSpinner color="#1cc2ff" />
		</div>
	);
}

const USAMapLoader = Loadable.Map({
	loader: {
		MapComponent: () => import(/* webpackChunkName: "map" */ "genericComponents/Map"),
		usaMapObject: () => import(/* webpackChunkName: "map" */ "lib/maps/us_map.js"),
		// usaMapObject: () => import(/* webpackChunkName: "map" */ "lib/maps/usMap--texas23-alt.js"),
		// usaMapObject: () => import(/* webpackChunkName: "map" */ "static/maps/usStates.json"),
		// reactSimpleMaps: () => import(/* webpackChunkName: "map" */ "react-simple-maps"),
		usStates: () => import(/* webpackChunkName: "map" */ "static/maps/svgJSON/blob.js"),
		// usStates: () => import(/* webpackChunkName: "map" */ "static/maps/counties/blob.js"),
		mapIndex: () => import(/* webpackChunkName: "map" */ "lib/maps/mapIndexUSA.js"),
		baseIcon: () => import(/* webpackChunkName: "map" */ "lib/maps/tinyUSA.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const { actions } = props;
		const Map = loaded.MapComponent.default;
		const usStates = loaded.usStates.default;
		const mapIndex = loaded.mapIndex.default;
		const baseIcon = loaded.baseIcon.default;
		const usaMapObject = loaded.usaMapObject.default;
		// const { reactSimpleMaps } = loaded;
		return (
			<Map
				{...props}
				reactSimpleMaps={null}
				// reactSimpleMaps={reactSimpleMaps}
				baseIcon={baseIcon}
				baseMapObject={usaMapObject}
				loaderID="USAMapLoader"
				states={usStates}
				mapIndex={mapIndex}
				clickableStates={["06"]}
				// highlightable={[{ name: "Texas 23rd", geoState: "texas23" }]}
				// trigger remount between detailed and base maps (prevents awkward transition)
				key={props.mapHighlight ? "mapHighlight" : "baseMap"}
				activeNarrativeData={props.activeNarrativeData}
				clearMap={actions.clearMap}
				clickMap={actions.clickMap}
				mapHighlightDisabled={false}
				mapId="base"
				scale={830}
				scaleDivider={700}
				subtractFromHeight={360}
				// actions
				clearMapPlay={actions.clearMapPlay}
				clickMap={actions.clickMap}
				hoverMap={actions.hoverMap}
				incrementMapPosition={actions.incrementMapPosition}
				setMapPosition={actions.setMapPosition}
				toggleMapPlay={actions.toggleMapPlay}
				unhoverMap={actions.unhoverMap}
			/>
		);
	},
});

export default USAMapLoader;
